import React from "react";
import { Link } from "react-router-dom";

function HeaderPrestataire() {
  return (
    <div className="container-fluid twyny-border-bottom">
      <header className="container d-flex justify-content-between align-items-center twyny-topbar">
        {/* Logo */}
        <div className="logo">
          <Link to="/">
            <img src="/logo.svg" alt="Twyny Logo" className="logo-img" />
          </Link>
        </div>
      </header>
    </div>
  );
}

export default HeaderPrestataire;
